<script setup>
import CompetitorTable from '@frontJs/components/tables/projectManagement/modules/CompetitorTable.vue';
import TenantReportCompetitorTable from '@frontJs/components/tables/projectManagement/modules/tenantReports/CompetitorTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Concurrents - Modules - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - Modules - Concurrents
    </PageTitle>

    <CompetitorTable v-if="tenant" :tenant="tenant" />

    <TenantReportCompetitorTable v-else />
</template>
